import React, { useState, useEffect, useRef } from 'react';

export default function ExamAttend() {

  return (
    <div style={{ background: '#f8f7fa', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      Test Exam Page
    </div>
  );
}
